var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-compare-container"},[_c('Checkbox',{staticClass:"date-compare-checkbox",model:{value:(_vm.limit),callback:function ($$v) {_vm.limit=$$v},expression:"limit"}},[_vm._v("\n    限制后续事件在时间区间内\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-038ab939","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/views/my-components/custom-date-picker/base/date-com-end.vue
// module id = null
// module chunks = 